/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Rails_Vibebids_ViewInputs */

const en_directory_rails_vibebids_view = /** @type {(inputs: Directory_Rails_Vibebids_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See the board`)
};

const zh_directory_rails_vibebids_view = /** @type {(inputs: Directory_Rails_Vibebids_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看榜单`)
};

/**
* | output |
* | --- |
* | "See the board" |
*
* @param {Directory_Rails_Vibebids_ViewInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_rails_vibebids_view = /** @type {((inputs?: Directory_Rails_Vibebids_ViewInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Rails_Vibebids_ViewInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_rails_vibebids_view(inputs)
	return zh_directory_rails_vibebids_view(inputs)
});
export { directory_rails_vibebids_view as "directory.rails.vibebids_view" }